<template>
  <div class="layout-container">
    <public-fixed-header ref="container-header" @noticeDisplayChange="initContainerStyle"></public-fixed-header>
    <div
      class="layout-container__inner syue-clr"
      :style="{'height': containerStyle.innerHeight}"
    >
      <sy-aside
        :style="{'float': !checkBrowserFlex ? 'left' : ''}"
        :page-text="pageText"
        :side-title="sideTitle"
        :menu-list="sideMenuList"
        :menu-props="{
          'submenuName': 'name', // 一级菜单名
          'menuList': 'appMenuList',  // 二级菜单list
          'menuItemName': 'applicationName', // 菜单项名称
          'menuItemUrl': 'url', // 菜单项跳转地址
          'menuItemIcon': 'iconUrl' // 菜单icon
        }"
        :collapse="collapse"
        @collapse:update="collapseChangeHandle"
      ></sy-aside>
      <sy-main :style="containerMainStyle">
        <router-view></router-view>
      </sy-main>
    </div>
    <side-fixed v-if="!$route.meta.hideSideFixed" type="fluid"></side-fixed>
    <!-- 系统公告 -->
    <system-announcement publishScope='mall' v-if="!$route.meta.noNotice"></system-announcement>
  </div>
</template>

<script>
import PublicFixedHeader from 'components/mall-public-container/public-fixed-header'
import SyMain from 'components/sy-container/sy-main'
import SyAside from 'components/sy-container/sy-aside'
import SideFixed from 'components/side-fixed/index.vue'
import i18n from './i18n.js'
import SystemAnnouncement from 'fe-coms/components/business/system-announcement/index.vue'
import {mapState} from 'vuex'

const pageText = window.fe.getPageText(i18n)

export default {
  name: 'layout-fluid',
  components: {
    PublicFixedHeader,
    SyMain,
    SyAside,
    SideFixed,
    SystemAnnouncement
  },
  data () {
    return {
      pageText,
      collapse: false,
      containerStyle: {
        innerHeight: '',
        headerHeight: '82px'
      }
    }
  },
  computed: {
    ...mapState({
      bottomContent: state => state.user.bottomContent,
      portalCode: state => state.checkAuth.portalCode,
      applicationClassifyList: state => state.user.applicationClassifyList
    }),
    checkBrowserFlex () {
      return 'flex' in document.documentElement.style
    },
    containerMainStyle () {
      let style = {}
      if (this.checkBrowserFlex) {
        style = {
          flex: 1
        }
      } else {
        style.width = `calc(100% - ${this.collapse ? '56px' : '170px'})`
      }
      return style
    },
    // 侧边栏菜单列表
    sideMenuList () {
      return this.applicationClassifyList || []
    },
    // 侧边栏名称
    sideTitle () {
      return this.portalCode === 'demandPortal' ? this.pageText.myWorkbench : this.pageText.myMall
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.initContainerStyle()
    })
  },
  methods: {
    collapseChangeHandle (collapse) {
      this.collapse = collapse
    },
    initContainerStyle () {
      if (!this.$refs['container-header']) return
      let headerHeight = ''
      this.$nextTick(() => {
        headerHeight = this.$refs['container-header'].$el.clientHeight
        this.containerStyle.innerHeight = `calc(100% - ${headerHeight}px)`
        this.containerStyle.headerHeight = `${headerHeight}px`
      })
    }
  }
}
</script>

<style scoped lang="scss">
.layout-container {
  min-width: 1200px;
  height: 100%;
  min-height: auto;
  background-color: #F7FBFF;
  overflow-y: hidden;
  .layout-container__inner {
    display: flex;
    overflow: hidden;
  }
  .sy-container__main {
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>
